<template>
    <div>
      <br class="hidden-xs-only">
      <div class="kongxi hidden-sm-and-up"></div>
      <el-card shadow="always" :body-style="{ padding: '20px' }">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
          <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content">
  <h2>防控知识宣传——“生物安全和蚁害防控知识”专题公益讲座</h2>
  <p>
  为满足广大物业管理单位环境安全管理需要，提升企业管理人员自身蚁害防控知识与技能，2023年8月1日下午，广东东进有害生物防控技术有限公司协同东莞市物业管理行业协会在东莞迎宾馆芙蓉厅共同举办了物业小区“生物安全和蚁害防控知识”专题公益讲座。
  </p>
  
  <img width="100%" :src="img[0]" alt="" class="image">
 
  
  <p>东莞市物业管理行业协会秘书长邓笑华、东莞市有害生物防制协会秘书长黄广元、广东东进有害生物防控技术有限公司总经理王伟出席本次讲座。协会相关人员及各物业公司代表积极参与。
  </p>
  
    <img width="100%" :src="img[1]" alt=""class="image">
 <br>
  <h3 style="text-align: center;margin-bottom: 15px;margin-top: 15px;">东莞市物业管理行业协会秘书长</h3>
  
  <img width="100%" :src="img[2]" alt="" class="image">
  
  <h3 style="text-align: center;">东莞市有害生物防制协会秘书长</h3>
  <p>
  在讲座开始前，东进公司总经理王伟发表致辞，他强调，有害生物防控是当前社会关注的热点问题，同时也是东进公司一直以来致力于解决的重要任务之一，它不仅关乎国民健康也关系经济发展。东进公司作为全国唯一一家专业针对有害生物防控防治的国有性质企业，一直秉承绿色、健康、环保的理念，积极践行国企责任，彰显国企担当，致力于打造优良防控技能，为众多客户提供优质服务。
  </p>
  <img width="100%" :src="img[3]" alt="" class="image">
  <h3 style="text-align: center;">广东东进有害生物防控技术有限公司总经理</h3>
  <p>
  为了给大家带来更专业而实用的知识，讲座特别邀请东莞市有害生物防制协会的丁祥翔老师作为主讲人。在课程中，丁祥翔老师与大家深入探讨了生物安全的重要性，介绍蚁虫的危害和防治方法，并分享了一些实用的防护技巧与经验。
  </p>
  <img width="100%" :src="img[4]" alt=""class="image">
  <h3 style="text-align: center;">东莞有害生物防制协会讲师</h3>
  <p>
  在讲座的最后，大家积极就老师所讲的内容提出自己的见解及困惑，老师结合工作实际对大家提出的问题进行了逐一分析与解答。
  </p>
  </div>
        <br>
        <br>
        <el-row :gutter="20">
          <el-col :span="12" :xs="24" :offset="0">
            <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({name: 'News7'})">&lt;
              上一条&nbsp;&nbsp;&nbsp;&nbsp;东进防控工会...</span>
          </el-col>
          <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
            <span style="cursor: pointer; color: #666; font-size: 14px"
              @click="$router.push({name: 'News5'})">广东东进有害生...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
          </el-col>
          </el-row>
        <br>
        <br>
      </el-card>
      <br class="hidden-xs-only">
      <div class="kongxi hidden-sm-and-up"></div>
    </div>
  </template>
  <script>
    export default {
      data () {
        return {
          img: [require('@/assets/news6.png'), require('@/assets/news6-1.png'), require('@/assets/news6-2.png'),require('@/assets/news6-3.png'),require('@/assets/news6-4.png'),require('@/assets/news6-5.png')]
        }
      }
    }
  </script>
  <style lang="scss" scoped>
    .kongxi {
      height: 10px;
    }
  
    .content {
      width: 90%;
      margin: 0 auto;
    
      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
      }
  
      h3 {
        margin-top: 15px;
        margin-bottom: 15px;
        font-size: 16px;
      }
  
      p {
        text-indent: 2em;
        font-size: 16px;
        margin: 30px 0;
        text-align: justify;
        color: #666;
        line-height: 24px;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
  
    @media screen and (max-width: 768px) {
      .content {
        width: 90%;
        margin: 0 auto;
  
        h2 {
          font-family: 黑体, SimHei;
          font-size: 24px;
          margin: 20px 0;
          text-align: center;
          font-size: 18px;
        }
  
        p {
          font-size: 16px;
          margin: 20px 0;
          text-align: justify;
          text-indent: 2em;
          color: #515050;
          font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
        }
  
        h3 {
          font-size: 16px;
        }
      }
    }
  </style>